<mat-sidenav-container fullscreen>
    <mat-sidenav #mainmenu>
        <mat-toolbar color="primary">
            <span class="toolbar-filler"></span>
            <button mat-icon-button>
                <mat-icon aria-label="Close menu" (click)="mainmenu.close()">close</mat-icon>
            </button>
        </mat-toolbar>

        <mat-list class="sidenav-buttons">
            <button mat-button [routerLink]="['/']" (click)="mainmenu.close()">
                <mat-list-item>
                    <mat-icon>home</mat-icon>
                    <label>Main Menu</label>
                </mat-list-item>
            </button>

            <mat-divider *ngIf="screenMenuItems?.length"></mat-divider>

            <div *ngFor="let menuItem of screenMenuItems">
                <mat-divider *ngIf="menuItem.break == true"></mat-divider>
                <button mat-button *ngIf="evaluateMenuItemCondition(menuItem)"
                    (click)="menuItem.handler.call(this.component); mainmenu.close();">
                    <mat-list-item>
                        <mat-icon *ngIf="menuItem.icon" [ngClass]="{'material-symbols-outlined': menuItem.iconOutlined}">{{menuItem.icon}}</mat-icon>
                        <span>{{menuItem.label}}</span>
                    </mat-list-item>
                </button>
            </div>
        </mat-list>
    </mat-sidenav>

    <mat-toolbar class="nav-header-menu" color="primary">
        <button mat-icon-button aria-label="Main menu" (click)="mainmenu.open()" *ngIf="currentRoute != '/'">
            <mat-icon>menu</mat-icon>
        </button>
        <div *ngIf="currentRoute == '/'" style="width:1em;"></div>

        <h1>{{ pageTitle }}</h1>

        <span class="toolbar-filler"></span>

        <button *ngIf="!buildIsUpToDate" mat-button (click)="systemUpdate()">
            <mat-icon color="warn">refresh</mat-icon>
        </button>
        <button mat-button [matMenuTriggerFor]="screenUsernameMenu">{{ username || '(Log in)' }}</button>
        <mat-menu #screenUsernameMenu>
            <button mat-menu-item (click)="doLogout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
        <button mat-button *ngIf="!inFullscreen" (click)="enableFullscreen()">
            <mat-icon>fullscreen</mat-icon>
        </button>
    </mat-toolbar>

    <div style="padding:5px 10px;">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
</mat-sidenav-container>